// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__eWzp0","form":"styles_form__3Rf_R"};